import {
  CustomNodeConfig,
  ContentBasedOnInput
} from 'src/viewLayer/components/nodes/PageNode/types';

const getLanguageLevel = (languageQuestionAnswer: string): string =>
  ['some', 'alot'].includes(languageQuestionAnswer) ? 'intermediate' : 'beginner';

export const getContentBasedOnInput = (
  inputConfig: ContentBasedOnInput,
  inputAnswer: string | undefined
): CustomNodeConfig => {
  let updatedInputAnswer = inputAnswer;

  if (inputConfig.id === 'language_level') {
    updatedInputAnswer = getLanguageLevel(inputAnswer);
  }

  return inputConfig[updatedInputAnswer];
};

